module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0013-c06ae6b1c4fa3843a33edbb01b4da5d5.jpg";